import store from "../../redux/reduxStore";

import { isTokenExpired } from "../../utils/auth";
import { fetchAccessToken } from "../auth";

import protectedRoutes from "./protectedRoutes";
import { removeAuth } from "../../redux/actions/auth/authActions";
import recommendedRoutesS1, { recommendedRoutesS2 } from "./recommendedRoutes";
import { getOrCreateDeviceId } from "../../utils/storage";
import deviceIdRoutes from "./diviceIdRoutes";

// Convert the routes to regex patterns
const routeToRegex = (route) => {
  return new RegExp(
    "^" + route.replace(/:[^\s/]+/g, "([^/]+)").replace(/\//g, "\\/") + "$"
  );
};

async function requestInterceptor(config) {
  const accessToken = store?.getState()?.auth?.access_token;
  const isLogged = localStorage.getItem("logged");

  const isDeviceIdRoute = deviceIdRoutes.some((route) => {
    const regex = routeToRegex(route);
    return regex.test(config.url);
  });

  if (isDeviceIdRoute) {
    config.headers["Device-ID"] = getOrCreateDeviceId();
  }

  const isProtectedRoute = protectedRoutes.some((route) => {
    const regex = routeToRegex(route);
    return regex.test(config.url);
  });

  if (!isLogged || !isProtectedRoute) return config;

  const shouldFetchNewToken = !accessToken || isTokenExpired(accessToken);

  try {
    if (shouldFetchNewToken) {
      const authDetails = await fetchAccessToken();
      const newAccessToken = authDetails.accessToken;
      config.headers["Authorization"] = `Bearer ${newAccessToken}`;

      // if logging out,  add the access_token in the body
      if (config.url === "logout") {
        config.data = {
          ...config.data,
          access_token: newAccessToken,
        };
      }
    } else {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
  } catch (error) {
    // Reject the promise to stop the request
    return Promise.reject(error);
  }

  return config;
}

export default requestInterceptor;

export async function recommendedrequestInterceptorS1(config) {
  const accessToken = store?.getState()?.auth?.access_token;
  const isLogged = localStorage.getItem("logged");

  const isRecommendedRoute = recommendedRoutesS1.some((route) =>
    config.url.includes(route)
  );

  if (!isLogged || !isRecommendedRoute) return config;

  const shouldFetchNewToken = !accessToken || isTokenExpired(accessToken);

  try {
    if (shouldFetchNewToken) {
      const authDetails = await fetchAccessToken();
      const newAccessToken = authDetails.accessToken;
      config.headers["Authorization"] = `Bearer ${newAccessToken}`;
    } else {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
  } catch (error) {
    const message = error?.response?.data?.error?.message;
    store.dispatch(removeAuth({ message }));
  }

  return config;
}

export async function recommendedrequestInterceptorS2(config) {
  const accessToken = store?.getState()?.auth?.access_token;
  const isLogged = localStorage.getItem("logged");

  const isRecommendedRoute = recommendedRoutesS2.some((route) =>
    config.url.includes(route)
  );

  if (!isLogged || !isRecommendedRoute) return config;

  const shouldFetchNewToken = !accessToken || isTokenExpired(accessToken);

  try {
    if (shouldFetchNewToken) {
      const authDetails = await fetchAccessToken();
      const newAccessToken = authDetails.accessToken;
      config.headers["Authorization"] = `Bearer ${newAccessToken}`;
    } else {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
  } catch (error) {
    const message = error?.response?.data?.error?.message;

    store.dispatch(removeAuth({ message }));
  }

  return config;
}
